import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
export type ResourceCatalogKind = 'skills' | 'categories';
@Injectable({ providedIn: 'root' })
export class ResourceTeamCatalogApiService {
  private readonly url = environment.apiBaseUrl + '/resourceplanning/team-catalogs';
  constructor(private http: HttpClient) {}
  get(teamId: number, kind: ResourceCatalogKind): Observable<number[]> {
    return this.http.get<number[]>(`${this.url}/${teamId}/${kind}`);
  }
  save(teamId: number, kind: ResourceCatalogKind, ids: number[]): Observable<void> {
    return this.http.put<void>(`${this.url}/${teamId}/${kind}`, ids);
  }
}
